import Vue from 'vue';

// 创建一个新的 Vue 实例作为事件总线
const EventBus = new Vue();

export default EventBus;
